<template>
  <v-dialog
    v-model="isOpened"
    persistent
    scrollable
    width="600px"
  >
    <domain-dialog
      v-model="isDomainDialogOpened"
      :maker="maker"
      @save="domainAdded"
    />
    <v-card v-if="maker">
      <v-card-title>
        Domaines d'intervention
      </v-card-title>
      <v-card-subtitle>
        {{ maker.name }}
      </v-card-subtitle>
      <v-divider />
      <v-card-text class="pa-3 mb-2">
        <v-row no-gutters justify="center" align="center" class="pt-6 pb-4" v-if="isFetchingDomains">
          <v-progress-linear
            indeterminate
            color= "primary"
            style="max-width: 200px;"
          />
        </v-row>
        <template v-else>
          <v-row no-gutters justify="center" align="center" class="pa-2 mt-2 text--secondary" style="min-height: 50px;" v-if="!domains.length">
            Aucun domaine
          </v-row>
          <v-row class="px-4 py-1" :justify="domains.length % 2 === 0 ? `center` : `start`" align="center">
            <v-col cols="6" v-for="domain in domains" :key="domain.id">
              <n-card depressed class="px-3 py-1 font-weight-medium" style="background: #EEE;">
                {{ domain.name }}
              </n-card>
            </v-col>
            <v-col cols="6">
              <v-row no-gutters justify="center" align="center">
                <v-btn :disabled="!$canWrite" text color="primary" class="mx-2" @click="$canWrite && (isDomainDialogOpened = true)">
                  <v-icon left>add</v-icon>
                  Nouveau domaine
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </template>
      </v-card-text>
      <v-divider />
      <v-card-actions class="py-3 px-6">
        <v-spacer></v-spacer>
        <v-btn
          color="primary darken-1"
          :disabled="domains.length < 1"
          @click="ended"
        >
          Étape suivante
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DomainDialog from '@/components/Domain/DomainDialog.vue';

export default {
  props: {
    value: Boolean,
    maker: Object,
  },
  data: () => ({
    domains: [],
    isFetchingDomains: false,
    isDomainDialogOpened: false,
  }),
  computed: {
    isOpened: {
      get() { return this.value; },
      set(value) { this.$emit(`input`, value); },
    },
  },
  methods: {
    initLocalState() {
      this.domains = [];
      this.fetchDomains();
    },
    ended() {
      this.isOpened = false;
      this.$emit(`ended`);
    },
    async fetchDomains() {
      this.isFetchingDomains = true;
      this.$store.commit(`model/domain/SET_MAKER_DOMAINS`, []);
      const domains = await this.$store.dispatch(`model/domain/fetchMakerDomains`, this.maker.id);
      this.domains.push(...domains);
      this.isFetchingDomains = false;
    },
    domainAdded(domain) {
      this.domains.push(domain);
    },
  },
  watch: {
    isOpened(isOpened) {
      if (isOpened) {
        this.initLocalState();
      }
    },
  },
  components: {
    DomainDialog,
  },
};
</script>
